import { render, staticRenderFns } from "./Controversy.vue?vue&type=template&id=09650e36&scoped=true"
import script from "./Controversy.vue?vue&type=script&lang=js"
export * from "./Controversy.vue?vue&type=script&lang=js"
import style0 from "./Controversy.vue?vue&type=style&index=0&id=09650e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09650e36",
  null
  
)

export default component.exports